import Header from "./Header";
import Footer from "./Footer";
import AboutHero from "./About_hero";

export const Home = () => {
    return (
        <div className="home">
            <div className="fade_home">
                <div className="main_theme"></div>
            </div>

            <div className="fade_header">
                <Header />
            </div>

            <div className="omnie">
                <AboutHero />
            </div>

            <Footer />
        </div>
    );
};

export default Home;
